import { ApplicationController } from './application_controller'

export default class extends ApplicationController {
  static targets = [
    'errorMessage',
    'paymentSelectionValidationErrorMessage',
    'form',
    'submitButton',
    'useStripeCheckout',
    'useSavedStripePaymentMethod',
    'savedCardHelpText',
    'savedCardWarning',
    'checkoutSubmitButtonText',
    'savedCardSubmitButtonText'
  ]

  static values = {
    'checkoutUrl': String,
    'savedCcUrl': String
  }

  savedCardHelpTextTargetConnected() {
    this.savedCardHelpTextTarget.style.display = 'none';
    this.savedCardWarningTarget.style.display = 'none';
  }

  async submit(event) {
    event.preventDefault()

    if (!this.paymentSelectionIsValid()) {
      Ladda.stopAll()
      return false
    }

    Ladda.create(this.submitButtonTarget).start()

    try {
      const formData = new FormData(this.formTarget)
      const formObject = Object.fromEntries(formData.entries())

      const response = await fetch(this.determineActionUrl(), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        },
        body: new URLSearchParams(new FormData(this.formTarget))
      })

      if (!response.ok) {
        throw response
      }

      const result = await response.json()

      if (result.no_charge) {
        window.location.replace(result.redirect_url)
      } else if (this.noPaymentSelector()) {
        this.stripe.redirectToCheckout({ sessionId: result.sessionId })
      } else if (this.useStripeCheckoutTarget.checked) {
        this.stripe.redirectToCheckout({ sessionId: result.sessionId })
      } else {
        window.location.replace(result.redirect_url)
      }

    } catch (errorResponse) {
      try {
        const errorData = await errorResponse.json()

        if (errorData.message === 'HumanVerification failed') {
          window.location.replace(errorData.redirect_url)
        } else {
          Ladda.stopAll()
          this.toggleError(errorData.message || 'An unexpected error occurred.')
        }
      } catch (err) {
        console.error("Error parsing error response:", err)
        Ladda.stopAll()
        this.toggleError('An unexpected error occurred.')
      }
    }
  }

  toggleError(message) {
    if (message.length) {
      this.errorMessageTarget.innerHTML = message
      this.errorMessageTarget.classList.remove('hide')
    } else {
      this.errorMessageTarget.innerHTML = ''
      this.errorMessageTarget.classList.add('hide')
    }
  }

  determineActionUrl() {
    if (this.noPaymentSelector()) {
      return this.checkoutUrlValue
    } else if (this.useSavedStripePaymentMethodTarget.checked) {
      return this.savedCcUrlValue
    } else if (this.useStripeCheckoutTarget.checked) {
      return this.checkoutUrlValue
    }
  }

  paymentSelectionIsValid() {
    if (this.noPaymentSelector()) {
      // Nothing to validate, so returning true
      return true
    } else if (this.useSavedStripePaymentMethodTarget.checked || this.useStripeCheckoutTarget.checked) {
      // A selection was made
      return true
    } else {
      // No selection was made so we display an error
      // Without using JS to do this, it doesn't work, because the actual main input is hidden
      // due to our need to have radio selection elements be fancy.
      this.paymentSelectionValidationErrorMessageTarget.classList.remove('hide')
      document.getElementsByClassName("pass_use_saved_stripe_payment_method")[0].focus()
      return false
    }
  }

  noPaymentSelector() {
    if (this.hasUseSavedStripePaymentMethodTarget) {
      return false
    } else {
      return true
    }
  }

  savedCardSelected() {
    this.savedCardHelpTextTarget.style.display = 'block';
    this.savedCardWarningTarget.style.display = 'none';

    if (this.hasSavedCardSubmitButtonTextTarget) {
      let newButtonText = '<span class="ladda-label">' + this.savedCardSubmitButtonTextTarget.innerHTML + '</span><span class="ladda-spinner"></span>'
      this.submitButtonTarget.innerHTML = newButtonText
    }
  }

  useStripeCheckoutSelected() {
    this.savedCardHelpTextTarget.style.display = 'none';
    this.savedCardWarningTarget.style.display = 'block';

    if (this.hasCheckoutSubmitButtonTextTarget) {
      let newButtonText = '<span class="ladda-label">' + this.checkoutSubmitButtonTextTarget.innerHTML + '</span><span class="ladda-spinner"></span>'
      this.submitButtonTarget.innerHTML = newButtonText
    }
  }
}
